<p class="text-error text-xs flex items-center" [class]="className">
  <svg-icon class="w-7 h-7 inline-block text-error mr-2" src="./assets/evsb/img/error.svg"></svg-icon>
  {{ error }}
</p>
